import { render, staticRenderFns } from "./Pangenation.vue?vue&type=template&id=70d37b42&scoped=true&"
import script from "./Pangenation.vue?vue&type=script&lang=ts&"
export * from "./Pangenation.vue?vue&type=script&lang=ts&"
import style0 from "./Pangenation.vue?vue&type=style&index=0&id=70d37b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d37b42",
  null
  
)

export default component.exports